<template>
  <el-card class="list p-2 px-3" :shadow="false" :body-style="{ padding: 0 }">
    <el-skeleton :rows="4" v-if="loading" animated />
    <template v-else>
      <div
        @click="handleClickItem(item)"
        class="list-item flex-one py-3 fs-xl px-1"
        :style="{
          'border-bottom':
            index < list.length - 1 ? '1px solid #dddddd' : 'none'
        }"
        v-for="(item, index) in list"
        :key="item.id"
      >
        <span class="mr-2 fw-600 fs-xxxl text-primary">· </span>
        <span
          style="flex: 1"
          class="title-item fs-xl cursor-p"
          :title="item.title"
        >
          {{ item.title }}
        </span>
        <span class="text-primary ml-2 fs-xl">{{ item.publishTime }}</span>
      </div>
    </template>
  </el-card>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'

const emits = defineEmits(['on-click'])

const props = defineProps({
  list: {
    type: Array
  },
  loading: Boolean
})

const handleClickItem = (option) => {
  emits('on-click', option)
}
</script>

<style lang="scss" scoped>
.list {
  // background-color: #d6ebf0; //d6ebf0
  background-color: #fff;
  // border: 1px solid #dddddd;
  &-item {
    color: #010101;
    // border-bottom: 1px solid #dddddd;
    transition: 0.8s opacity;
    .title-item {
      &:hover {
        opacity: 0.8;
        text-decoration: underline;
      }
    }
    &:hover {
      opacity: 0.9;
    }
  }
}
</style>
